export enum BankAccountProfileTabsEnum {
  ACCOUNT_DETAILS = 'account-details',
  PAYMENTS = 'payments',
  PREFERENCES = 'preferences',
}
